import React, { useState, useRef } from "react";
import "./SizeDropdown.css";

const SizeDropdown = ({
  options = [],
  selectedValue,
  onChange,
  placeholder = "Select Option",
  // Legacy props for backward compatibility
  sizes,
  selectedSize
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Handle legacy props
  const finalOptions = options.length > 0 ? options : (sizes || []).map(size => ({ value: size, displayText: size }));
  const finalSelectedValue = selectedValue !== undefined ? selectedValue : selectedSize;

  const handleOptionSelect = (optionValue) => {
    setIsOpen(false);
    if (onChange) {
      onChange(optionValue); // Call the parent's onChange function
    }
  };

  // Get display text for selected value
  // Get display text for selected value
  const getSelectedDisplayText = () => {
    if (!finalSelectedValue) return placeholder;

    const selectedOption = finalOptions.find(opt =>
      (typeof opt === 'object' ? opt.value : opt) === finalSelectedValue
    );

    if (selectedOption) {
      return typeof selectedOption === 'object'
        ? selectedOption.displayText
        : selectedOption;
    }

    return finalSelectedValue;
  };

  // Close dropdown when clicking outside - using ref for this specific dropdown
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="size-dropdown-container" ref={dropdownRef}>
      {/* Button that opens the dropdown */}
      <button className="size-dropdown-button" onClick={() => setIsOpen(!isOpen)}>
        {getSelectedDisplayText()}
        <span className="dropdown-icon">&#9662;</span> {/* Down arrow icon */}
      </button>

      {/* Dropdown menu */}
      {isOpen && (
        <ul className="size-dropdown-menu">
          {finalOptions.map((option, index) => {
            const optionValue = typeof option === 'object' ? option.value : option;
            const displayText = typeof option === 'object' ? option.displayText : option;

            return (
              <li
                key={index}
                className="size-option"
                onClick={() => handleOptionSelect(optionValue)}
              >
                {displayText}
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
};

export default SizeDropdown;